var map = {
	"./cooking.jpg": 7766,
	"./economy.jpg": 918,
	"./electronics.jpg": 8571,
	"./japan.jpg": 6482,
	"./kanada.jpg": 2282,
	"./nature.jpg": 3089,
	"./physics.jpg": 7673,
	"./relax.jpg": 1004,
	"./seal.jpg": 7191,
	"./seal2.jpg": 5221,
	"./seal3.jpg": 904,
	"./telecommunications.jpg": 4943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2375;